var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{staticClass:"notice-area",attrs:{"is-dot":""}},[_c('icon',{attrs:{"name":"notice","scale":2.8}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }